import { render, staticRenderFns } from "./SearchAlgolia.vue?vue&type=template&id=540c3618"
import script from "./SearchAlgolia.vue?vue&type=script&lang=js"
export * from "./SearchAlgolia.vue?vue&type=script&lang=js"
import style0 from "./SearchAlgolia.vue?vue&type=style&index=0&id=540c3618&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports